function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStuckUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-15 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m481 0h-262.214844l-98.785156 98.785156v83.214844c-49.625 0-90 40.375-90 90s40.375 90 90 90 90-40.375 90-90c0-39.109375-25.078125-72.46875-60-84.851562v-67.148438h90v-90h211v392h-227.109375c-20.777344-35.839844-59.566406-60-103.890625-60-66.167969 0-120 53.832031-120 120v30h240v-30c0-10.355469-1.320312-20.40625-3.796875-30h244.796875zm-301 272c0 33.085938-26.914062 60-60 60s-60-26.914062-60-60 26.914062-60 60-60 60 26.914062 60 60zm-8.785156-182 38.785156-38.785156v38.785156zm-141.214844 392c0-49.625 40.375-90 90-90s90 40.375 90 90zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345 212c-8.269531 0-15-6.730469-15-15h-30c0 19.554688 12.539062 36.226562 30 42.421875v32.578125h30v-32.578125c17.460938-6.195313 30-22.867187 30-42.421875 0-11.953125-4.597656-23.347656-12.945312-32.078125-8.582032-8.976563-19.964844-13.921875-32.054688-13.921875-7.992188 0-15-7.476562-15-16 0-8.269531 6.730469-15 15-15s15 6.730469 15 15h30c0-19.554688-12.539062-36.226562-30-42.421875v-32.578125h-30v32.578125c-17.460938 6.195313-30 22.867187-30 42.421875 0 11.953125 4.597656 23.347656 12.945312 32.078125 8.582032 8.976563 19.964844 13.921875 32.054688 13.921875 7.992188 0 15 7.476562 15 16 0 8.269531-6.730469 15-15 15zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 362h181v30h-181zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240 302h181v30h-181zm0 0",
    fill: "#000000",
    style: {
      fill: "rgb(0, 122, 255)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuckUp);
export default __webpack_public_path__ + "static/media/stuck_up.45cf9a0009ead29f22b9fbb01e9d14fc.svg";
export { ForwardRef as ReactComponent };